import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { ExtensionDocumentDetails } from '../../../shared/ExtensionDocuments';

const labels = { amount: 'Сумма в рублях', percent: 'Процент',
  cash: 'Наличные', card: 'Карта', transfer: 'Перевод', ozon: 'Онлайн' };

// Only presentation of saved facts; no recalculation or mutation from a history row.
export default function RentalHistoryDetails({ event, formatDate }) {
  const value = (raw, kind) => {
    if (raw === null || raw === undefined) return 'Не указано';
    if (kind === 'date') return formatDate(raw);
    if (kind === 'money') return `${Number(raw).toLocaleString('ru-RU')} ₽`;
    return labels[raw] || String(raw);
  };
  return <Box sx={{ mb: 1 }}>
    {event.extension_document && <ExtensionDocumentDetails doc={event.extension_document} formatDate={formatDate} />}
    {event.period && <Typography variant="body2">
      Период при выдаче: {value(event.period.start, 'date')} — {value(event.period.end, 'date')}
    </Typography>}
    {(event.changes || []).map(change => <Typography variant="body2" key={change.field}>
      {change.label}: {value(change.before, change.kind)} → {value(change.after, change.kind)}
    </Typography>)}
    {event.payment_cancelled && <Alert severity="warning">Платёж отменён. Запись сохранена в истории.</Alert>}
  </Box>;
}
